import script from "./RadioGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&setup=true&lang=ts"

import "./RadioGroup.vue?vue&type=style&index=0&id=713866ee&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-713866ee"]])

export default __exports__